module.exports = __webpack_public_path__ + "img/noAuth.f418753a.png";